import { lazy } from "react";
import { build } from "app/main/tools/ConfigBuilder";

const requestBusinessDebitCardPath = {
	path: "/admin/transactions/create-business-debit-card",
	component: lazy(() => import("./TransactionsStateCreateBusinessDebitCardPage")),
};

export default build([...(false ? [requestBusinessDebitCardPath] : [])]); // TODO: WALLET_FEATURE gk
